import { ListResponseType } from 'services/types'
import {
  TBakersAttribute,
  TBakersCategory,
} from 'types/models/BakersAttributes'
import { Axios } from 'utils'

export const useBakersAttributesService = () => {
  const getBakersAttributes = async () => {
    try {
      const response = await Axios.get<ListResponseType<TBakersAttribute>>(
        '/baker/products/attributes'
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const getBakersCategoriesWithAttributes = async () => {
    try {
      const response = await Axios.get<ListResponseType<TBakersCategory>>(
        '/baker/products/categories/attributes'
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  return {
    getBakersAttributes,
    getBakersCategoriesWithAttributes,
  }
}
